import { render, staticRenderFns } from "./DownloadTendersToExcel.vue?vue&type=template&id=90a723b0"
import script from "./DownloadTendersToExcel.vue?vue&type=script&lang=js"
export * from "./DownloadTendersToExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports